var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7999 7.56135L14.9966 16.9754C14.9966 16.9754 14.7443 17.6281 14.0512 17.315L9.89065 14.0116L9.87135 14.0018C10.4334 13.4792 14.7913 9.42161 14.9818 9.23768C15.2767 8.95283 15.0936 8.78325 14.7513 8.99843L8.31398 13.2318L5.83049 12.3665C5.83049 12.3665 5.43966 12.2225 5.40206 11.9095C5.36396 11.5959 5.84335 11.4264 5.84335 11.4264L15.9678 7.31338C15.9678 7.31338 16.7999 6.93477 16.7999 7.56135Z",
    fill: "#0483F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.b6b8852f887923b5c8eef0524877630d.svg";
export { ForwardRef as ReactComponent };